import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Config from "../Config";
import LoginScreen from "../Views/Auth/LoginScreen";

import MainScreenNavigator from "./MainScreenNavigators";

function AppNavigator() {
  return (
    <Router basename={Config.relativePath}>
      <Routes>
        <Route path="/login" exact element={<LoginScreen />} />
        <Route path="*" element={<MainScreenNavigator />} />
      </Routes>
    </Router>
  );
}

export default AppNavigator;
